// extracted by mini-css-extract-plugin
module.exports = {"content":"MeetingEvent_content__3WA8X","fullWidth":"MeetingEvent_fullWidth__PMZot","compact":"MeetingEvent_compact__361nT"};